//late version
//new version 2025-12-23
import { System_DeviceOrientationMap } from '../assets/keyMap';
import { AppContext } from '../Context';
import './styles/VideoPreviewer.scss';
import { useContext, useState } from 'react';

//muis
import CloseIcon from '@mui/icons-material/Close';

interface Props {
    src: string
    className?: string
}

const VideoPreviewer:React.FC<Props> = ({ src, className }) => {
    //context
    const appContext = useContext(AppContext);
    // //states
    const [shouldShowVideo, SetShouldShowVideo] = useState<boolean>(false);

    //render functions
    const RenderVideoViewer = () => {
        return(
            <div className={'VideoPreviewer-menu ' + (className ? className : '')}>
                <iframe className='VideoPreviewer-menu-player' src={src} allowFullScreen frameBorder="0">Your browser does not support video tag.</iframe>
                <button className='VideoPreviewer-menu-close-btn' onClick={() => SetShouldShowVideo(false)}><CloseIcon/></button>
            </div>
        )
    }

    return(
        <div className={'VideoPreviewer ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')}>
            {/** dummy video loader */}
            <button className='VideoPreviewer-btn' onClick={() => SetShouldShowVideo(true)}>
                <iframe src={src} className='VideoPreviewer-btn-img' style={{pointerEvents: 'none'}}/>
            </button>

            {
                shouldShowVideo ?
                RenderVideoViewer()
                :
                null
            }
        </div>
    )
}
export default VideoPreviewer;